import { render } from "./manageDetail.vue?vue&type=template&id=f8eb14c0&scoped=true"
import script from "./manageDetail.vue?vue&type=script&lang=js"
export * from "./manageDetail.vue?vue&type=script&lang=js"

import "./manageDetail.vue?vue&type=style&index=0&id=f8eb14c0&lang=scss&scoped=true"
import "./manageDetail.vue?vue&type=style&index=1&id=f8eb14c0&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8eb14c0"]])

export default __exports__